import styled from "styled-components";

export const SliderWithCheckbox = styled.section`
  padding-top: 15px;
`;
